import { render, staticRenderFns } from "./help.vue?vue&type=template&id=23166c76&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=23166c76&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23166c76",
  null
  
)

export default component.exports